



















import Vue from 'vue'
import store from '@/store'

export default Vue.extend({
  name: 'SignupIntro',

  data: () => ({
    store,
  }),

  methods: {
    async submit(e: Event) {
      e.preventDefault()
      this.$router.push({ name: 'SignupCustomer' })
    },
  },
})
